import { render, staticRenderFns } from "./CharacterGrid.vue?vue&type=template&id=231ae4bd&scoped=true&"
import script from "./CharacterGrid.vue?vue&type=script&lang=js&"
export * from "./CharacterGrid.vue?vue&type=script&lang=js&"
import style0 from "./CharacterGrid.vue?vue&type=style&index=0&id=231ae4bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231ae4bd",
  null
  
)

export default component.exports